import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AgentInboxMappingService {
  TokenCls;
  InboxInventoryId: number;
  InboxInventoryLogId: number;
  getCategoryName: string;
  getCategoryId: number;

  // Start Idecision Tree pre-analysis
  public preAnalysisQuestionList = new BehaviorSubject([]);
  public postQuestionList = new BehaviorSubject([]);

  public preAnalysisNotes = new BehaviorSubject([]);
  public postNotes = new BehaviorSubject([]);

  public storePreNotes = new BehaviorSubject([]);

  public storeFinalPreQuestionsAnswers = new BehaviorSubject([]);
  public storeFinalPostQuestionsAnswers = new BehaviorSubject([]);

  public backupQuestionList = new BehaviorSubject([]);
  // End Idecision Tree pre-analysis

  public setSubscenarioId = new BehaviorSubject<number>(0);

  public ClaimAssistSubject = new BehaviorSubject<any>([]);
  public setIsAvailable = new BehaviorSubject<boolean>(false);

  public newInbox_Name = new BehaviorSubject<string>('');

  is_PreAnalysis: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  getAgentcategory(clientId): any {
    console.log("addNewLine() service : ");
    return this.http
      .get(environment.ApiUrl + `/api/get-agent-category/${clientId}`)
      .pipe(map((res) => res));
  }

  getAgentQueue(clientId, category): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/get-agent-queue/${clientId}?category=${category}`)
      .pipe(map((res) => res));
  }


  getAgentInbox(clientId, queue, subQue): any {
    return this.http
      // .get(
      //   environment.ApiUrl + `/api/get-agent-inbox/${clientId}?Queue=${queue}`)
      // .pipe(map((res) => res));

      .get(
        environment.ApiUrl + `/api/Concluder_Inboxs_Name_Count_Scenario_/Get/${clientId}/${queue}/${subQue}`)
      .pipe(map((res) => res));
  }
  getCimAgentAccount(clientId, queue, inbox): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/cim-agent-account/${clientId}?queue=${queue}&inbox=${inbox}`)
      .pipe(map((res) => res));
  }

  GetInboxAllFields(clientId, inventoryid, inventoryLogId, queue_Name, Inbox_Name, WorkType, Current_Status?): any {
    return this.http.get(
      environment.ApiUrl + `/api/cim-agent-field/${clientId}/${inventoryid}/${inventoryLogId}?queue=${queue_Name}&inbox=${Inbox_Name}&WorkType=${WorkType}&Current_Status=${Current_Status}`);
  }

  UpdateInventoryTimeInbox(formobj: any): any {
    console.log('UpdateInventoryTime formobj Inbox : ', formobj)
    return this.http.put(environment.ApiUrl + '/api/cim-agent-time', formobj);
  }

  SaveAllFieldsInbox(formobj): any {
    return this.http.put(environment.ApiUrl + '/api/cim-agent-field', formobj);
  }
  InsertEndTimeOfInboxInventory(formobj): any {
    return this.http.post(environment.ApiUrl + '/api/cim-agent-time', formobj)
  }

  getScenarioQuestions(clientId, scenarioId, inventoryId, categoryName) {
    return this.http.get(environment.ApiUrl + `/api/iDecisionTree-Questions/${clientId}/${scenarioId}/${inventoryId}/${categoryName}`).pipe(map((res) => res));
  }

  getScenarioQuestionsStaging(clientId, scenarioId, inventoryId, categoryName, IsPreviewStaging=0) {
    if (IsPreviewStaging == 1) {
return this.http.get(environment.ApiUrl + `/api/iDecisionTree-QuestionsStaging/${clientId}/${scenarioId}/${inventoryId}/${categoryName}`).pipe(map((res) => res));
    } else{
      return this.http.get(environment.ApiUrl + `/api/iDecisionTree-Questions/${clientId}/${scenarioId}/${inventoryId}/${categoryName}`).pipe(map((res) => res));
    }
  }

  SaveiDecisionTreeValues(formobj) {
    console.log("sendddd", formobj);
    return this.http.post(environment.ApiUrl + '/api/Concluder-ScenarioQuestion-Answer', formobj)

  }
  getAgentCategoryQueue(clientId, categoryId): any {
    return this.http.get(environment.ApiUrl + `/api/Concluder-Queue-Scenario-Name-Count/${clientId}?Category_ID=${categoryId}`)
      .pipe(map((res) => res));
  }
  // for standard fields data
  getCimAgentScenarioAccount(clientId, queue, inbox, scenarioName, Isinboxclicked: boolean = false): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/cim-agent-account/${clientId}?queue_Id=${queue}&inbox_Id=${inbox}&Scenario_Id=${scenarioName}&IsinboxClicked=${Isinboxclicked}`)
      .pipe(map((res) => res));
  }
  // on agent screen/view button for questions and answers
  getviewScenarioPage(clientId, inventoryId, inventoryLogId, scenarioId, getCateroryId): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/iDecisionTree-QuestionAnswer/${clientId}/${inventoryId}/${inventoryLogId}/${scenarioId}/${getCateroryId}`)
      .pipe(map((res) => res));
  }


  // on focus event for TFL and AFL (carerul function)
  getcarerulResponse(carerulObj): any {
    return this.http
      .post(
        environment.ApiUrl +
        '/api/ConcluderinboxLimitFuncation', carerulObj)
      .pipe(map((res) => res));
  }

  // api for get multi grid inbox data
  getAgentInboxMultiGridList(clientId, queue_Id, inbox, scenario): any {
    return this.http.get(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?Queue_Id=' + queue_Id + '&inbox=' + inbox + '&Scenario=' + scenario);
  }

  // API for submit iAgent multigrid data
  saveiAgentMultiGridFields(clientId, bucket_Name, inbox, scenario, formobj): any {
    return this.http.put(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?bucket_Name=' + bucket_Name + '&inbox=' + inbox + '&Scenario=' + scenario, formobj);
  }

  // For iAGent View page
  getiAgentInboxViewMultiGridList(clientId, inventory_Id, inventory_log_Id, bucket_Name, inbox, scenario): any {
    return this.http.get(environment.ApiUrl + '/api/agent-view-Multigrid/client/' + clientId + '/' + inventory_Id + '/' + inventory_log_Id + '/?bucket_Name=' + bucket_Name + '&inbox=' + inbox + '&Scenario=' + scenario);
  }

  // submit action code
  SaveiDecisionActionCode(formobj) {
    return this.http.post(environment.ApiUrl + '/api/Get_Action_Code', formobj)
  }

  // Get All provider name
  getAllProviderNames(clientId) {
    return this.http.get(environment.ApiUrl + '/api/provider/client/' + clientId);
  }

  // Get InventoryTotalTime
  getInventoryTotalTime(clientId, inventoryLogid) {
    return this.http.get(environment.ApiUrl + '/api/Get_InventoryTotal_Time/' + clientId + '/' + inventoryLogid);
  }

  // GetNoResponse
  getCimAgentAccountNR(clientId, queue_id) {
    return this.http.get(environment.ApiUrl + '/api/cim-agent-account-NR/' + clientId + '?queue_id=' + queue_id);
  }

  // GetNoResponse
  getScenariosListNR(clientId, queue_id) {
    return this.http.get(environment.ApiUrl + '/api/Scenario-List/' + clientId);
  }

  // saveGridAccounts
  saveGridAccounts(clientId, queue, formobj) {
    return this.http.post(environment.ApiUrl + '/api/No-response-submit/client/' + clientId + '?Queue_Id=' + queue, formobj)
  }

  // Intra Vertical getCimAgentAccountNR
  getCimAgentAccountIV(clientId, categoryId, queueId, scenarioId) {
    return this.http.get(environment.ApiUrl + '/api/cim-agent-account-IV/' + clientId + '?Category_Id=' + categoryId + '&Queue_Id=' + queueId + '&scenario_Id=' + scenarioId);
  }

  // saveGridAccounts
  saveIVGridAccounts(clientId, queueId, scenarioid, formobj) {
    return this.http.post(environment.ApiUrl + '/api/Intravertical-submit/client/' + clientId + '?Queue_Id=' + queueId + '&Scenario_Id=' + scenarioid, formobj)
  }

  // getOtherCategoryMultiGridList
  getOtherCategoryMultiGridList(clientId, queue_Id): any {
    return this.http.get(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?Queue_Id=' + queue_Id);
  }
  GetClaim_Assist(reqObject) {
    return this.http.post(environment.ApiUrl + '/api/Claim_Assist/GetClaim_Assist', reqObject);
  }
  getagentOthersmultiplegrid(clientId, queue_Id): any {
    return this.http.get(environment.ApiUrl + '/api/agent-Others-multiple-grid/client/' + clientId + '/?Queue_Id=' + queue_Id);
  }


  //submit Claim Assist Data
  saveClaimAssistData(formobj) {
    return this.http.post(environment.ApiUrl + '/api/Claim_Assist/SubmitClaim_Assist', formobj)
  }

  getAgentOthersCBFfields(clientId, inventory_Id): any {
    return this.http.get(environment.ApiUrl + '/api/agent-Others-CBFfields/client/' + clientId + '/?inventory_Id=' + inventory_Id);
  }
}


// for Work_Type
export enum Work_Type {
  ANALYSIS = 'ANALYSIS',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  INBOX = 'INBOX'
}
